import React from 'react'
import { Dialog } from '../atoms'
import Button from '@mui/material/Button'
import { ImageCropper, ImageEditorDisclaimer } from '../molecules'
import { ReactCropperElement } from 'react-cropper'

interface ConfirmProfilePictureModalProps {
    open?: boolean
    selectedImage?: string
    onImageChange(image: string): void
    onSaveClick(): void
    onClose(): void
}

export const ConfirmProfilePictureModal = React.forwardRef(
    (
        props: ConfirmProfilePictureModalProps,
        ref: React.ForwardedRef<ReactCropperElement>
    ) => {
        return (
            <Dialog
                open={!!props.open}
                title="Confirm Profile Picture"
                content={
                    <>
                        <ImageCropper
                            selectedImage={props.selectedImage}
                            onImageChange={props.onImageChange}
                            ref={ref}
                            squareCrop
                        />
                        <ImageEditorDisclaimer />
                    </>
                }
                ctas={[
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={props.onClose}
                        key="cancel"
                    >
                        Cancel
                    </Button>,
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={props.onSaveClick}
                        key="save"
                    >
                        Save
                    </Button>,
                ]}
                onClose={props.onClose}
            />
        )
    }
)
